import { useState, type CSSProperties } from 'react'
import type { FaceDesign } from '@v2/sdk'
import { Icon } from './icons'

/** This component receives only the permitted face; private fronts never become image URLs. */
export function FaceArt({ art, label, hidden = false, color }: { art?: FaceDesign; label: string; hidden?: boolean; color?: string }) {
  const [imageAspect, setImageAspect] = useState(1)
  const [failedSource, setFailedSource] = useState<string | null>(null)
  if (art?.image && art.imageRotation && failedSource !== art.image) {
    const sideways = art.imageRotation === 90 || art.imageRotation === 270
    const aspect = sideways ? 1 / imageAspect : imageAspect
    return <div style={{ position: 'relative', width: '100%', aspectRatio: aspect, overflow: 'hidden' }}>
      <img src={art.image} alt={hidden ? 'Card back' : art.title || label}
        style={{ position: 'absolute', left: '50%', top: '50%', width: `${sideways ? 100 / aspect : 100}%`, maxWidth: 'none', transform: `translate(-50%, -50%) rotate(${art.imageRotation}deg)` }}
        onLoad={event => setImageAspect(event.currentTarget.naturalWidth / event.currentTarget.naturalHeight)} onError={() => setFailedSource(art.image!)}/>
    </div>
  }
  if (art?.image && failedSource !== art.image) return <img className="tt-inspect-image" src={art.image} alt={hidden ? 'Card back' : art.title || label} onError={() => setFailedSource(art.image!)}/>
  return <div className={`tt-inspect-art${hidden ? ' is-hidden' : ''}`} style={{ '--art-color': art?.color ?? color ?? '#436347', '--art-background': art?.background ?? '#f3f0e4' } as CSSProperties}>
    <div className="tt-art-symbol"><Icon name={art?.symbol === 'sun' || art?.symbol === 'star' ? 'sun' : 'leaf'} size={56}/></div>
    <div className="tt-art-title">{hidden ? art?.title ?? 'Face down' : art?.title ?? label}</div>
    {art?.subtitle && <p className="tt-art-subtitle">{art.subtitle}</p>}
    {!hidden && art?.value !== undefined && <strong className="tt-art-value">{art.value}</strong>}
    {art?.body && <p className="tt-art-body">{art.body}</p>}
    {art?.footer && <div className="tt-art-footer">{art.footer}</div>}
  </div>
}
